// Confirmation prompt removed per request.
// Kept the same signature so every call site (`if (!generateCaptcha(...))`)
// keeps working — it now always passes, so no dialog is shown anywhere.
const generateCaptcha = () => true;

module.exports = generateCaptcha;
